/*
 * @Author: changcheng
 * @LastEditTime: 2023-10-11 17:20:13
 */
import "./index.scss";
export default function FinishCourse(props: { text: string }) {
  const { text } = props;
  return <div className="finishCourse">{text}</div>;
}
